// `type`, not `interface`: useParams<T> constrains T to Record<string, string | undefined>,
// which only a type alias satisfies (interfaces have no implicit index signature).
export type MatchParams = {
    userId: string;
};

export const enum UserPageName {
    Prices = 'prices',
    Price = 'price',
    UserProfile = 'userProfile',
    SiteProfile = 'siteProfile',
    ScheduleSettings = 'scheduleSettings',
    Notifications = 'notifications',
    SubscriptionUserPrice = 'subscriptionUserPrice',
}
